export default "__VITE_ASSET__c6b70030__"